import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import UserDetails from './form/UserDetails.js';
import UserPassword from './form/UserPassword.js';
import Notification from '../../components/Notification.js';
import {setUserKey,setCurrentUser,setUserSetting} from '../../actions/Login.js';
import Auth from '../../modules/Auth.js';
import Dropzone from 'react-dropzone';
import LoadingSmall from '../../components/LoadingSmall';
import Switch from 'rc-switch';


class SettingsProfile extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isSavingDetails:false,
			isUploading:false
		}

		this.handleImageReset = this.handleImageReset.bind(this);

		this.handleSubmit = this.handleSubmit.bind(this);
		this.onOpenClick = this.onOpenClick.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.resetNotifications = this.resetNotifications.bind(this);
	}

	onDrop(files) {
        if(files.length == 0) {
            return;
        }

        this.setState({isUploading:true});

        let data = new FormData();
        data.append('file', files[0]);

		axios.post('/ajax/upload_profile_image',data)
		.then(res => {
			this.setState({isUploading:false});
			this.props.setUserKey('image',res.data.image);

		}).catch(err => {
			this.setState({isUploading:false});
		});
    }

	onOpenClick() {
      this.refs.dropzone.open();
    }

	componentWillMount() {

	}

    resetNotifications() {
		localStorage.removeItem('notifications');
		location.reload();
	}

	handleImageReset() {
		axios.post('/ajax/upload_profile_image')
		.then(res => {
			this.setState({isUploading:false});
			this.props.setUserKey('image',res.data.image);

		}).catch(err => {
			this.setState({isUploading:false});
		});
	}

	componentDidMount() {
	}

	handleSubmit(values) {
		this.setState({
			isSavingDetails:true
		});

		axios.put('/me',values).then(res => {
			this.setState({
				isSavingDetails:false
			});
			this.props.setCurrentUser(Auth.getToken(),res.data);

			Notification.success('Success!');
		}).catch(err => {
            this.setState({
                isSavingDetails:false
            });
			Notification.error(err.response.data.error.message);
		});
	}

	handleNotificationChange = (key,e) => {
		if(e === true) {
			e = 1;
		}

		if(e === false) {
			e = 0;
		}

		this.props.setUserSetting(key,e);
	}

	handleNotificationSave = () => {
		Notification.info('Saving..');

		axios.put('/me/settings',{
			settings:this.props.auth.user.settings
		}).then(res => {
			Notification.success('Success!');
		}).catch(err => {
			Notification.error(err.response.data.error.message);
		});
	}

	render() {

		return (
			<div className="full-height">
				<Helmet title="Profile | Crall.io" />
				<div className="page-header">
					<span className="page-title"><i className="icon wb-user"></i> Profile</span>
				</div>

				<div className="page-content">

				<OptionColumn title="Details" description="Change your user details.">
					<UserDetails isSavingDetails={this.state.isSavingDetails} onSubmit={this.handleSubmit} />
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="Profile" description="Change profile picture. This picture will be visible to other users and visitors.">
					<div className="col-sm-6 text-center">
						<img src={this.props.auth.user.image} style={{width:'200px'}} />

					</div>
					<div className="col-sm-6">
						<br />
						<br />
						<Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
		    				{
		    					this.state.isUploading ?
		    						<LoadingSmall />
		    					:
		    					<button type="button" onClick={this.onOpenClick} className="btn btn-dark btn-block">Upload image</button>
		    				}
		    			</Dropzone>
						<br />
						<button className="btn btn-dark btn-block" onClick={this.handleImageReset}>Reset image</button>

					</div>
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="Password" description="Change your password">
					<UserPassword isSavingDetails={this.state.isSavingDetails} onSubmit={this.handleSubmit} />
				</OptionColumn>

				<SplitRows />

				<OptionColumn title="E-mail notifications" description="Enable or disable notifiactions">
					<div className="col-sm-12">
						Select which events you wan't to be notified about.<br /><br />
						<table className="table ">
							<tr>
								<td>New offline chat message</td>
								<td>
									<Switch onChange={(e) => this.handleNotificationChange('NOTIFY_NEW_CHAT_MESSAGE',e)}
											checked={(this.props.auth.user.settings.NOTIFY_NEW_CHAT_MESSAGE == '1' ? true:false)}
											checkedChildren={<i className="icon fa-check"></i>}
											unCheckedChildren={<i className="icon fa-close"></i>}
									/>
								</td>
							</tr>
						</table>
					</div>
					<div className="col-sm-12">
						<button className="btn btn-dark btn-block" onClick={this.handleNotificationSave}>Save</button>
					</div>
				</OptionColumn>

				<SplitRows />

					<OptionColumn title="Browser notifications" description="Re-run notification activation process">
						<div className="col-sm-6">
							If you are experiencing issues regarding receiving alerts / notifications from Crall you can try to reset your settings.<br /><br />
							1. Follow the steps in this <a target="_blank" href="http://docs.crall.io/chat/varsel-ved-nye-meldinger">guide</a><br />
							2. Click "Reset notifications" to the right
						</div>
						<div className="col-sm-6">
							<button className="btn btn-dark btn-block" onClick={this.resetNotifications}>Reset notifiations</button>
						</div>
					</OptionColumn>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setUserKey,setCurrentUser,setUserSetting},dispatch)
}


SettingsProfile = connect(mapStateToProps,mapDispatchToProps)(SettingsProfile);
export default SettingsProfile;



// WEBPACK FOOTER //
// ./containers/settings/SettingsProfile.js